<script setup lang="ts">
import { computed } from 'vue';
import { customCellMap, type TechDataTableCellProps } from './utils';

const props = defineProps<TechDataTableCellProps>();

const CustomCellComponent = computed(() => customCellMap[props.row.id]);
</script>
<template>
  <CustomCellComponent v-if="CustomCellComponent" v-bind="props"></CustomCellComponent>
  <span v-else>{{ value.value }}</span>
</template>
